import { render, staticRenderFns } from "./ScrollLayout.vue?vue&type=template&id=20e95317"
import script from "./ScrollLayout.vue?vue&type=script&lang=js"
export * from "./ScrollLayout.vue?vue&type=script&lang=js"
import style0 from "./ScrollLayout.vue?vue&type=style&index=0&id=20e95317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports